const faqs = [
  {
    question: 'What is a VigorBuy Spreadsheet?',
    answer: 'A VigorBuy Spreadsheet is a curated collection of product links, seller information, and pricing data organized in an easy-to-browse format. It helps shoppers discover trusted products across categories like shoes, clothing, bags, and accessories — all in one centralized resource updated daily.',
  },
  {
    question: 'How do I use a VigorBuy Spreadsheet to find products?',
    answer: 'Simply browse the categories on this hub page, click on any category to explore VigorBuy Spreadsheet links, and you will be redirected to the main platform where you can view detailed product listings, seller ratings, QC photos, and current pricing for thousands of items.',
  },
  {
    question: 'Are VigorBuy Spreadsheet sellers verified?',
    answer: 'Yes. Every seller featured in the VigorBuy Spreadsheet goes through a manual verification process. We check seller ratings, order history, QC photo quality, and shipping reliability before including them. This ensures you only access trusted, reliable sellers.',
  },
  {
    question: 'How often is the VigorBuy Spreadsheet updated?',
    answer: 'The VigorBuy Spreadsheet is updated daily. New products, seller information, and pricing data are refreshed to ensure you always have access to the latest finds. Our team continuously monitors for new sellers and product additions.',
  },
  {
    question: 'Is the VigorBuy Spreadsheet free to use?',
    answer: 'Absolutely. The VigorBuy Spreadsheet resource is completely free to browse. You can explore all categories, view seller ratings, and compare products without any cost. Simply click through to start discovering trusted products.',
  },
  {
    question: 'Can I find specific brands in the VigorBuy Spreadsheet?',
    answer: 'Yes! The VigorBuy Spreadsheet covers a wide range of brands including Nike, Jordan, Yeezy, Stussy, Essentials, Supreme, and many more. Use the search function or browse by category to find exactly what you are looking for.',
  },
];

export default function FAQSection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Frequently Asked <span className="text-accent-500">Questions</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            Everything you need to know about the VigorBuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</h3>
                <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-5 h-5 flex-shrink-0 hidden group-open:flex items-center justify-center text-accent-500">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}